import { FieldsType } from '../services';

export const helperTexts: Record<string, string> = {
  [FieldsType.USER_PHONE]: 'consumer_web_helpers_phone',
  [FieldsType.USER_EMAIL]: 'consumer_web_helpers_email',
  [FieldsType.ORIGINAL_REQUEST_ID]: 'consumer_web_helpers_original-request-id',
};
